import { Button, Flex, Typography, theme, notification } from "antd";
import React, { useEffect, useState } from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { AESDecryption } from "../../../utils/Aes";
import { maskEmail } from "react-email-mask";
import AuthRestAPI from "../../../restAPI/AuthRestAPI";

const { Title, Text } = Typography;

export default function ProcessEnd() {
  const RESEND_WAIT_SECONDS = 30;
  const navigate = useNavigate();
  const {
    token: { colorPrimary },
  } = theme.useToken();

  const [countdown, setCountdown] = useState(0);
  const [email, setEmail] = useState("");
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement,
    });
  };

  const startCountdown = () => {
    const endTime = new Date(Date.now() + RESEND_WAIT_SECONDS * 1000);
    localStorage.setItem("resendCountdownEnd", endTime.toISOString());
    localStorage.setItem("resendCountdownExpired", "false"); // Mark countdown as active
    setCountdown(RESEND_WAIT_SECONDS);
  };

  useEffect(() => {
    if (window.location.href.includes("/web/process-end?email=")) {
      const parts = window.location.href.split("?email=");
      setEmail(AESDecryption(parts[1]));
    }
    const savedEndTime = localStorage.getItem("resendCountdownEnd");
    const countdownExpired = localStorage.getItem("resendCountdownExpired");

    // start countdown only if not previously expired
    if (savedEndTime && countdownExpired !== "true") {
      const remaining = Math.floor(
        (new Date(savedEndTime).getTime() - Date.now()) / 1000
      );
      if (remaining > 0) {
        setCountdown(remaining);
      } else {
        localStorage.removeItem("resendCountdownEnd");
        localStorage.setItem("resendCountdownExpired", "true");
      }
    } else if (!savedEndTime && countdownExpired !== "true") {
      // first mount scenario
      startCountdown();
    } else {
      // if expired previously, no countdown
      setCountdown(0);
    }

    const timer = setInterval(() => {
      const savedEndTime = localStorage.getItem("resendCountdownEnd");
      if (savedEndTime) {
        const remaining = Math.floor(
          (new Date(savedEndTime).getTime() - Date.now()) / 1000
        );
        if (remaining > 0) {
          setCountdown(remaining);
        } else {
          localStorage.removeItem("resendCountdownEnd");
          localStorage.setItem("resendCountdownExpired", "true");
          setCountdown(0);
        }
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const goBack = () => {
    navigate("/login");
  };

  const resendEmail = async () => {
    const formData = { email: email };
    await AuthRestAPI.resendAccVerification(formData)
      .then((response) => {
        openNotificationWithIcon(
          "success",
          "Successful",
          `${response.message}`,
          "bottomLeft"
        );
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Resend email failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Resend email failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  };

  return (
    <Flex
      vertical
      justify="center"
      style={{ minHeight: "calc(100svh - 246px)" }}
    >
      <CheckCircleFilled style={{ color: colorPrimary, fontSize: 78 }} />
      <Title level={3}>Successfully Recorded Your Data</Title>
      <Text type="secondary">
        We have sent a verification email to{" "}
        <Text code>{maskEmail(email)}</Text> <br />
        Please check your email and click the Verify Button to verify your
        email.
      </Text>
      <Flex
        justify="flex-start"
        align="center"
        style={{ marginTop: 30 }}
        gap={12}
      >
        <Button
          type="default"
          size="large"
          disabled={countdown > 0}
          onClick={resendEmail}
        >
          {countdown > 0
            ? `Resend Email (Wait ${countdown} Seconds)`
            : "Resend again"}
        </Button>
        <Button type="primary" onClick={goBack} size="large">
          Go Back
        </Button>
      </Flex>
      {contextHolder}
    </Flex>
  );
}
